<template>
  <admin-wrapper :straight-title="additionalModuleName" :module-enabler="moduleEnabler" :inputs="inputs">
  </admin-wrapper>
</template>

<script>
import { get } from 'vuex-pathify';

import AdminWrapper from '@/components/AdminWrapper';

export default {
  name: 'BufferSettings',
  components: { AdminWrapper },
  computed: {
    additionalModuleName: get('admin/additionalModules@BUFFER.verbose_name'),
    coordinatesEpsgs: get('map/coordinatesEpsgs'),
    coordinatesEpsgsArray() {
      return Object.values(this.coordinatesEpsgs)
        .map(epsgData => ({
          text: epsgData.text,
          value: epsgData.srid,
        }))
        .filter(epsg => ![4326, 3857].includes(epsg.value));
    },
    moduleEnabler() {
      return {
        name: 'buffer_module_enabled',
        straightText: this.additionalModuleName,
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.additionalModuleName }),
      };
    },
    inputs() {
      return [
        {
          name: 'buffer_srid',
          translationPath: 'admin.bufferCoordinateSystem',
          dataType: { name: 'select' },
          items: this.coordinatesEpsgsArray,
          rules: [v => !!v || v == '0' || 'rules.required'],
        },
      ];
    },
  },
};
</script>
